import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import size from 'lodash/size';
import isArray from 'lodash/isArray';
import { BackButton, PageTitle } from '../ui';
import {
  FileUploadIcon,
  SpinnerIcon,
  TrashIcon,
  UploadIcon,
} from '../../icons';
import { getFormJSON } from '../../utils/functions';
import { useUploadUsers } from '../../hooks/react-query/useAdmin';
import { toast } from '../ui/Toast/useToast';
import { downloadCSV } from '../../transactions/download/download';

const UploadMultipleUser = ({ handleBackClick }) => {
  const { mutate: uploadUserTemplate, isLoading } = useUploadUsers();
  const [erorUrl, setErrorUrl] = useState('');

  const [fileUploadState, setFileUploadState] = useState({
    file: {},
    driversMimeType: '',
    classes: 'is-valid',
    urlErrors: '',
  });

  const handleFileUpload = (event) => {
    event.preventDefault();
    let jsonData = getFormJSON(event);
    let data = new FormData(event.target);
    if (fileUploadState.file.file) {
      jsonData['users_file'] = fileUploadState.file.file;
      data.set('users_file', fileUploadState.file.file);
    }

    uploadUserTemplate(data, {
      onSuccess: (response) => {
        if (response.data === 'success') {
          if (response.exceptions) {
            if (size(response.exceptions) > 0) {
              const exceptionsArray = isArray(response.exceptions);
              const message = exceptionsArray
                ? response.exceptions.slice(-1)
                : 'Παρουσιάστηκε κάποιο πρόβλημα';
              toast({
                variant: 'destructive',
                description: message || 'Παρουσιάστηκε κάποιο πρόβλημα',
              });
              setFileUploadState({
                file: { file: '', name: '' },
                driversMimeType: '',
                classes: '',
              });
              if (response?.url) {
                setErrorUrl(response?.url);
              }
            }
          }
          toast({
            variant: 'success',
            description: 'Επιτυχής υποβολή αρχείου',
          });

          setFileUploadState({
            file: { file: '', name: '' },
            driversMimeType: '',
            classes: '',
          });
          setErrorUrl('');
        } else {
          if (response.exceptions) {
            if (size(response.exceptions) > 0) {
              const exceptionsArray = isArray(response.exceptions);
              const message = exceptionsArray
                ? response.exceptions.slice(-1)
                : 'Παρουσιάστηκε κάποιο πρόβλημα';
              toast({
                variant: 'destructive',
                description: message || 'Παρουσιάστηκε κάποιο πρόβλημα',
              });
              setFileUploadState({
                file: { file: '', name: '' },
                driversMimeType: '',
                classes: '',
              });
              if (response?.url) {
                setErrorUrl(response?.url);
              }
            }
          } else {
            toast({
              variant: 'destructive',
              description: 'Παρουσιάστηκε κάποιο πρόβλημα',
            });
          }
          setFileUploadState({
            file: { file: '', name: '' },
            driversMimeType: '',
            classes: '',
          });
        }
      },
      onError: () => {
        toast({
          variant: 'destructive',
          description: 'Παρουσιάστηκε κάποιο πρόβλημα',
        });
      },
    });
  };

  const handleFileChange = (fileArr) => {
    const [file] = fileArr;

    if (file) {
      let type = file.type.split('/')[1];
      let fileName = file.name;
      const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      setFileUploadState({
        file: { file, name: fileName, fileSize: `${sizeInMB} MB` },
        driversMimeType: type,
        urlErrors: '',
      });
    }
  };

  const handleRejectedFiles = () => {};

  const handleCancelClick = () => {
    setFileUploadState({
      file: { file: '', name: '' },
      driversMimeType: '',
      classes: '',
      urlErrors: '',
    });
  };

  const isFileSelected =
    !!fileUploadState?.file && !!fileUploadState?.file.file;

  return (
    <div>
      <form onSubmit={handleFileUpload}>
        <section className="container mx-auto py-10 overflow-x-hidden">
          <div className="flex flex-col gap-7 pb-7">
            <BackButton
              text="Back to Users"
              handleBackClick={handleBackClick}
            />
            <PageTitle
              title={<h2>Φόρτωση αρχείου excel</h2>}
              subTitle={
                'Παρακαλώ αναρτήστε το αρχείο excel που περιλαμβάνει τους χρήστες που επιθυμείτε να εισάγετε.'
              }
              displaySearch={false}
            />
          </div>
          <div className="flex  flex-col gap-y-6 p-6 bg-white rounded-lg justify-between">
            <div className="flex items-center gap-6">
              <h3>Upload the filled Template</h3>
            </div>
            <div className="flex justify-center p-3 self-center lg:w-[30%] w-full">
              <Dropzone
                onDrop={(acceptedFiles) =>
                  handleFileChange(acceptedFiles, 'deposit')
                }
                accept={{
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                    ['.xlsx', '.xls', '.csv'],
                }}
                noClick={true}
                noKeyboard={true}
                maxFiles={1}
                id="upload-btn-id-front"
                name="deposit"
                onDropRejected={(errors) => handleRejectedFiles(errors)}
              >
                {({ getRootProps, getInputProps, open, isDragActive }) => (
                  <div
                    {...getRootProps({
                      className: `${
                        isDragActive
                          ? 'border border-fadedgrey border-dashed flex justify-between'
                          : 'border border-fadedgrey border-dashed'
                      }  p-3 rounded-xl flex flex-col h-[172px] w-full ${
                        fileUploadState?.classes || ''
                      }`,
                    })}
                  >
                    {isFileSelected && (
                      <div className="flex justify-between w-full">
                        <FileUploadIcon />
                        <TrashIcon
                          onClick={handleCancelClick}
                          width={32}
                          height={32}
                          color="#4E4E4E"
                        />
                      </div>
                    )}

                    {!isFileSelected && (
                      <label
                        htmlFor="uploadDrivers"
                        onClick={open}
                        className={`${
                          isDragActive ? 'label-hidden ' : ''
                        } uploader-label w-full h-[85%] flex justify-center items-center `}
                      >
                        <input {...getInputProps()} className="h-[172px]" />
                        {isDragActive && (
                          <div className="uploader-drag-drop standing-order">
                            Αφήστε Εδώ
                          </div>
                        )}
                        {!fileUploadState ||
                          (!fileUploadState.file?.name && (
                            <div className="flex flex-col items-center justify-center gap-4">
                              <UploadIcon />
                              <span className="text-body text-fadedgrey">
                                (csv, xls, xlsx)
                              </span>
                            </div>
                          ))}
                      </label>
                    )}
                    <div
                      className={
                        isDragActive ? 'invisible' : 'flex flex-col pb-3'
                      }
                    >
                      <h5 className="text-fadedgrey">
                        {fileUploadState.file?.name}
                      </h5>
                      <div className="pt-2 text-body text-fadedgrey">
                        {fileUploadState.file?.fileSize}
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            </div>

            <div className="flex flex-col items-center gap-4 justify-end h-[90%]">
              {erorUrl && (
                <button
                  type="button"
                  className="text-link"
                  onClick={() => downloadCSV(erorUrl)}
                >
                  Download error logs
                </button>
              )}
              <button
                type="submit"
                className="btn-primary text-primary-button flex gap-2 justify-center items-center max-lg:w-full"
                disabled={!fileUploadState || !fileUploadState.file?.name}
              >
                {isLoading && <SpinnerIcon />}
                Upload
              </button>
            </div>
          </div>
        </section>
      </form>
    </div>
  );
};

export default UploadMultipleUser;
